import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({ selector: '[oaiboxLazyLoader]' })
export class LazyLoaderDirective implements OnInit, OnDestroy {
  @Output() loadMoreData: EventEmitter<void> = new EventEmitter();

  private observer?: IntersectionObserver;

  constructor(
    private element: ElementRef
  ) { }

  ngOnInit(): void {
    this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.loadMoreData.emit();
          this.observer?.unobserve(this.element.nativeElement);
        }
      },
      { threshold: 1.0 }
    );

    this.observer.observe(this.element.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
